/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { LiteralsService } from '../../services/literals-service';

export const DEVICE_BUTTON_CARD_STYLE = 'po-sm-12 po-offset-md-10 po-offset-xl-11 po-offset-lg-11 po-md-3 po-xl-1 po-lg-1';
export const DEVICE_BUTTON_TABLE_STYLE = 'po-offset-md-10 po-offset-xl-11 po-offset-lg-11 po-md-3 po-xl-1 po-lg-1 po-sm-12';

@Component({
  selector: 'tgv-device-button',
  standalone: false,
  templateUrl: './device-button.component.html',
  styleUrls: ['./device-button.component.css']
})
export class DeviceButtonComponent implements OnInit {
  @Output() changeDevice = new EventEmitter();
  @Input() isDeviceSmartPhone: boolean;
  isRelativePosition: boolean;
  literals: LiteralsWords;
  classDevice = '.rel-container';

  constructor(
    protected literalsService: LiteralsService
  ) {
    this.literals = this.literalsService.getLiteralModule();
  }

  ngOnInit(): void {
    this.isRelativePosition = !this.isDeviceSmartPhone;
    this.setClassDevice(this.isDeviceSmartPhone);
  }

  onChangeDevice(isSmartPhone: boolean): void {
    this.isDeviceSmartPhone = isSmartPhone;
    this.setClassDevice(isSmartPhone);
    this.emitDeviceChange(isSmartPhone);
  }

  setClassDevice(isSmartPhone: boolean): void {
    if (!this.canUseSmartPhoneStyle()){
      this.classDevice = this.getClassDevice(isSmartPhone);
    }
  }

  getClassDevice(isSmartPhone: boolean): string {
    return isSmartPhone ? DEVICE_BUTTON_CARD_STYLE: DEVICE_BUTTON_TABLE_STYLE;
  }

  canUseSmartPhoneStyle(): boolean {
    return this.isRelativePosition;
  }

  emitDeviceChange(isSmartPhone: boolean): void {
    this.changeDevice.emit(isSmartPhone);
  }
}
